import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Theme,
  createStyles,
} from "@material-ui/core";
import GroupIcon from "@material-ui/icons/Group";
import { makeStyles, withStyles } from "@material-ui/styles";
import { useAppDispatch, useAppSelector } from "app/hooks";
import BACKGROUND from "assets/img/bg_create_test.png";
import InputField from "components/FormFields/InputField";
import managerTestApi from "api/managerTest";
import {
  fetchDataOptions,
  selectListDepartment,
  selectListClass,
} from "features/Auth/options/optionsSlice";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import CreateQuestion from "./components/CreateQuestion";
import ManageExamStudentsModal from "components/ManageExamStudentsModal";

import { Pagination } from "@material-ui/lab";
import EmptyComponent from "components/Empty";
import { RadioGroupField } from "components/FormFields/RadioGroupFiled";
import {
  fetchPrizeList,
  selectFilterPrizeList,
} from "features/Admin/pages/ManagerPrize/managerPrizeSlice";
import { ListExam, Question } from "models/managerTest";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { dateTimeToFormatYYYYHHMM } from "utils/dateTimeFormat";
import * as yup from "yup";
import {
  SelectFilterListExam,
  SelectListExam,
  fetchListExam,
  setFilterListExam,
} from "../../managerExamListSlice";
import PickOldExamComponent from "./components/PickOldExam";


import { useSearchParams } from "react-router-dom";
import { Stepper, Step, StepLabel } from "@material-ui/core";
import { deduplicateQuestions } from "utils/examPreview";
export default function AddExam() {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      display: "flex",
      alignItems: "center",
      marginBottom: 15,
      width: "100%",
      "& .MuiFormGroup-root": {
        flexDirection: "row",
      },
    },
    background: {
      backgroundImage: `url(${BACKGROUND})`,
      backgroundSize: "cover",
      backgroundPositionX: "right",
      backgroundRepeat: "no-repeat",
      height: 130,
      width: "100%",
      position: "relative",
      "& >h6": {
        position: "absolute",
        top: 50,
        left: 0,
        color: "#004673",
        fontSize: 25,
        fontWeight: 700,
      },
    },
    title: {
      fontSize: 15,
      fontWeight: 600,
      width: "20%",
      [theme.breakpoints?.up("xl")]: {
        fontSize: 18,
        width: "17%",
      },
    },

    btn_create: {
      background: "linear-gradient(360deg, #399BD9 0%, #83CFFF 172.67%)",
      color: "#fff",
      borderRadius: 20,
      padding: "10px 15px",
    },
    container: {
      maxHeight: 500,
      "& .MuiButton-root.Mui-disabled": {
        color: "#fff",
      },
    },
    checkbox: {
      color: "#DADADA",
      borderRadius: 5,
    },
  }));
  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "16px 5px",
        background: "linear-gradient(360deg, #399BD9 0%, #83CFFF 172.67%)",
        color: "#fff",
        fontSize: 11,
        fontWeight: 700,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        borderBottom: "1px solid #777777",
        zIndex: 99,
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
      body: {
        padding: "16px 5px",
        fontSize: 11,
        borderRight: "1px solid rgba(224, 224, 224, 0.8)",

        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
    })
  )(TableCell);
  const { t } = useTranslation();

  const schema = yup.object().shape({
    startDateTime: yup.string().required(`${t("managerTest.vuilongchonngaykiemtra")}`),
    examTime: yup.string().required(`${t("managerTest.vuilongnhapthoigianthi")}`),
    totalPoint: yup.string().required(`${t("managerTest.vuilongnhapthoigianthi")}`),
    departmentId: yup.string().when("allDepartment", {
      is: false,
      then: yup.string().required(`${t("managerTest.vuilongchonbophan")}`),
    }),
    classId: yup.array().min(1, "*Vui lòng chọn lớp học"),
    category: yup.string().required("*Vui lòng chọn hình thức kiểm tra"),
  });
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentStep = Number(searchParams.get("step") || "1");
  const modeParam = searchParams.get("mode") || "create";

  const department = useAppSelector(selectListDepartment);
  const classList = useAppSelector(selectListClass);
  const filter = useAppSelector(selectFilterPrizeList);

  const [valueForm, setValueForm] = useState<Question | undefined>(() => {
    try {
      const saved = sessionStorage.getItem("gpet_add_exam_form");
      return saved ? JSON.parse(saved) : undefined;
    } catch (e) {
      return undefined;
    }
  });

  useEffect(() => {
    if (valueForm) {
      try {
        sessionStorage.setItem("gpet_add_exam_form", JSON.stringify(valueForm));
      } catch (e) {}
    }
  }, [valueForm]);

  useEffect(() => {
    if (currentStep > 1 && !valueForm) {
      setSearchParams({ step: "1" }, { replace: true });
    }
  }, [currentStep, valueForm, setSearchParams]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [createQuestion, setCreateQuestion] = useState(false);
  const [isPickOldExam, setIsPickOldExam] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isShowMainExam, setIsShowMainExam] = useState(true);
  const [openStudentModal, setOpenStudentModal] = useState(false);

  useEffect(() => {
    dispatch(fetchDataOptions());
    dispatch(fetchPrizeList(filter));
  }, [dispatch, filter]);

  const isDev = process.env.NODE_ENV === "development";
  const initialValue: any = {
    departmentId: "",
    type: "",
    startDateTime: isDev ? moment().add(1, 'days').format("YYYY-MM-DDTHH:mm") : "",
    examTime: isDev ? "60" : "",
    prizeId: "",
    totalPoint: isDev ? "100" : "",
    allDepartment: true,
    category: isDev ? "multipleChoice" : "",
    publishAnswerDateTime: "",
    hiddenAnswerDateTime: "",
    allClass: isDev ? true : false,
    classId: [],
    userId: [],
  };
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: initialValue,
    resolver: yupResolver(schema),
  });




  const handleSubmitForm = async (value: any) => {
    const startIso = value.startDateTime;
    const publishIso = value.publishAnswerDateTime;
    const hiddenIso = value.hiddenAnswerDateTime;

    if (startIso && moment(startIso).isBefore(moment(), "minute")) {
      toast.error(`${t("managerTest.vuilongchongiokiemtralonhonhoacbanggiohientai")}`);
      return;
    }

    const examMinutes = Number(value.examTime) || 0;
    const endMoment = moment(startIso).add(examMinutes, "minutes");

    const classIdList = value.classId;
    const userIdList = value.userId;

    setValueForm({
      ...value,
      startDate: startIso,
      time: moment(startIso).format("HH:mm"),
      publishAnswerDate: publishIso || null,
      hiddenAnswerDate: hiddenIso || null,
      prizeId: Number(value.prizeId) || "",
      totalPoint: Number(value.totalPoint) || "",
      type: value.category === "multipleChoice" ? "CHOICES" : "TYPING",
      classId: value.allClass ? classList.map((x) => x.id) : classIdList,
      userIdList: userIdList.length > 0 ? userIdList : null,
      departmentId: department.map((x) => x.id),
      endDate: endMoment.format("YYYY-MM-DDTHH:mm"),
    });
    const isPickingOld = listExamOldAdded.length > 0 && isOldExam === "true";
    if (isPickingOld) {
      try {
        const examIds = listExamOldAdded.map((x) => x.id).join(",");
        const batchRes: any = await managerTestApi.getBatchExamDetails(examIds, false);
        if (batchRes && batchRes.exams && batchRes.exams.length > 0) {
          setListOldExamAdded(batchRes.exams);
        }
      } catch (err) {
        console.error(err);
      }
    }
    setIsPickOldExam(isPickingOld);
    setCreateQuestion(!isPickingOld);
    setIsShowMainExam(false);
    setSearchParams({ step: "2", mode: isPickingOld ? "pick-old" : "create" });
  };

  // Table old exam
  const [isOldExam, setIsOldExam] = useState("false");
  const typeExam = watch("category");
  const filterListExam = useAppSelector(SelectFilterListExam);
  const listExam = useAppSelector(SelectListExam);
  const [listExamOldAdded, setListOldExamAdded] = useState<ListExam[]>([]);
  const [listQuestionsAdded, setListQuestionsAdded] = useState([]);
  const [initialRandomCount, setInitialRandomCount] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (isOldExam === "true") {
      if (typeExam === "multipleChoice") {
        dispatch(fetchListExam({ ...filterListExam, type: "CHOICES" }));
      } else {
        dispatch(fetchListExam({ ...filterListExam, type: "TYPING" }));
      }
    } else {
      dispatch(fetchListExam(filterListExam));
    }
  }, [dispatch, filterListExam, isOldExam, typeExam]);

  const handleChangePage = (page: number) => {
    dispatch(
      setFilterListExam({
        ...filterListExam,
        page: page - 1,
      })
    );
  };

  const handleAddExam = (exam: any) => {
    const cloneListAdded = [...listExamOldAdded];
    const findItem = cloneListAdded?.findIndex((x) => x.id === exam.id);
    if (findItem < 0) {
      cloneListAdded.push({ ...exam });
      setListOldExamAdded(cloneListAdded);
    } else {
      const newListAdded = cloneListAdded.filter((item) => item.id !== exam.id);
      setListOldExamAdded(newListAdded);
    }
  };

  return (
    <Box>
      <Stepper activeStep={Math.min(Math.max(currentStep - 1, 0), 2)} alternativeLabel style={{ marginBottom: 20, backgroundColor: "transparent" }}>
        <Step>
          <StepLabel>{`1. ${t("managerTest.step.cauhinhbaithi")}`}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{`2. ${t("managerTest.step.soanchoncauhoi")}`}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{`3. ${t("managerTest.step.xemtruocvanop")}`}</StepLabel>
        </Step>
      </Stepper>

      {currentStep >= 2 && (modeParam === "pick-old" || isPickOldExam) ? (
        <PickOldExamComponent
          valueForm={valueForm}
          setValueForm={setValueForm}
          setListQuestionsAdded={setListQuestionsAdded}
          listQuestionsAdded={listQuestionsAdded}
          data={listExamOldAdded}
          setCreateQuestion={(val: boolean) => {
            setCreateQuestion(val);
            if (val) setSearchParams({ step: "2", mode: "create" });
          }}
          setIsPickOldExam={(val: boolean) => {
            setIsPickOldExam(val);
            if (val) setSearchParams({ step: "2", mode: "pick-old" });
          }}
          setIsShowMainExam={(val: boolean) => {
            setIsShowMainExam(val);
            if (val) setSearchParams({ step: "1" });
          }}
          setInitialRandomCount={setInitialRandomCount}
        />
      ) : currentStep >= 2 ? (
        <CreateQuestion
          valueForm={valueForm}
          setValueForm={setValueForm}
          setCreateQuestion={(val: boolean) => {
            setCreateQuestion(val);
            if (val) setSearchParams({ step: "2", mode: "create" });
          }}
          listQuestionsAdded={deduplicateQuestions(listQuestionsAdded)}
          setIsPickOldExam={(val: boolean) => {
            setIsPickOldExam(val);
            if (val) setSearchParams({ step: "2", mode: "pick-old" });
          }}
          initialRandomCount={initialRandomCount}
        />
      ) : (
        <form onSubmit={handleSubmit(handleSubmitForm)} style={{ paddingBottom: 80 }}>
          <Box>
            <Box className={classes.background}>
            <Typography variant="subtitle2">{t("managerTest.themmoi").toUpperCase()}</Typography>
          </Box>
          <Box
            style={{
              backgroundColor: "#F8FAFC",
              borderRadius: 16,
              border: "1px solid #E2E8F0",
              padding: "18px 24px",
              marginTop: 16,
              marginBottom: 24,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <Box display="flex" alignItems="center" style={{ gap: 16 }}>
              <Box
                style={{
                  backgroundColor: "#0284C7",
                  color: "#FFFFFF",
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <GroupIcon style={{ fontSize: 28 }} />
              </Box>
              <Box>
                <Typography style={{ fontWeight: 800, fontSize: "1rem", color: "#0F172A" }}>
                  Danh Sách Lớp & Học Viên Dự Thi
                </Typography>
                <Typography style={{ fontSize: "0.85rem", color: "#64748B", marginTop: 2 }}>
                  Đã chọn: <b style={{ color: "#0284C7" }}>{(watch("classId") || []).length} Lớp học</b> •{" "}
                  <b style={{ color: "#10B981" }}>
                    {(watch("userId") || []).length > 0
                      ? `${(watch("userId") || []).length} Học viên chọn riêng`
                      : "Tất cả học viên trong lớp"}
                  </b>
                </Typography>
              </Box>
            </Box>

            <Button
              variant="contained"
              onClick={() => setOpenStudentModal(true)}
              startIcon={<GroupIcon />}
              style={{
                backgroundColor: "#0284C7",
                color: "#FFFFFF",
                fontWeight: 700,
                fontSize: "0.875rem",
                borderRadius: 10,
                padding: "8px 20px",
                textTransform: "none",
                boxShadow: "0 4px 12px rgba(2, 132, 199, 0.25)",
              }}
            >
              Chọn Lớp & Danh Sách Học Viên
            </Button>
          </Box>

          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerTest.ngaygiokiemtra")}
            </Typography>
            <Box width="80%">
              <InputField
                control={control}
                type="datetime-local"
                label=""
                name="startDateTime"
                size="small"
                borderRadius="12px"
              />
            </Box>
          </Box>

          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerTest.thoigianhienthidapan")}
            </Typography>
            <Box width="80%">
              <InputField
                control={control}
                type="datetime-local"
                label=""
                name="publishAnswerDateTime"
                size="small"
                borderRadius="12px"
              />
            </Box>
          </Box>

          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerTest.thoigianandapan")}
            </Typography>
            <Box width="80%">
              <InputField
                control={control}
                type="datetime-local"
                label=""
                name="hiddenAnswerDateTime"
                size="small"
                borderRadius="12px"
              />
            </Box>
          </Box>
          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerTest.thoigianlambai")}
            </Typography>
            <Box width="30%">
              <InputField
                control={control}
                name="examTime"
                label={t("managerTest.nhapthoigianthi")}
              />
              <Box ml={3}>
                <Typography variant="subtitle2" component="i" style={{ color: "#999999" }}>
                  ({t("managerTest.vidu")}: 100 = 01:40:00)
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerTest.hinhthuckiemtra")}
            </Typography>

            <RadioGroupField
              name="category"
              label=""
              control={control}
              options={[
                { label: `${t("managerTest.tracnghiem")}`, value: "multipleChoice" },
                { label: `${t("managerTest.tuluan")}`, value: "essay" },
              ]}
            />
          </Box>

          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerTest.tongdiem")}
            </Typography>
            <Box width="30%">
              <InputField
                control={control}
                name="totalPoint"
                label={t("managerTest.nhaptongdiem")}
              />
            </Box>
          </Box>

          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerTest.dungdethicu")}
            </Typography>

            <RadioGroup
              name="oldExam"
              onChange={(event) => setIsOldExam(event.target.value)}
              value={isOldExam}
            >
              <FormControlLabel
                value="true"
                control={<Radio color="primary" size="small" />}
                label={t("managerTest.co")}
                disabled={typeExam === "" ? true : false}
              />
              <FormControlLabel
                value="false"
                control={<Radio color="primary" size="small" />}
                label={t("managerTest.khong")}
                disabled={typeExam === "" ? true : false}
              />
            </RadioGroup>
          </Box>
          {isOldExam === "true" && (
            <Box m={2}>
              {listExam?.totalPages > 0 ? (
                <TableContainer component={Paper} className={classes.container}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell width="100px" align="center">
                          {t("luachon")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {t("managerTest.tieudebaithi")}
                        </StyledTableCell>
                        <StyledTableCell align="center" width="100px">
                          {t("managerTest.socauhoi")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {t("managerTest.thoigian")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {t("managerTest.tongdiem")}
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {listExam?.content.map((exam, index) => (
                        <TableRow key={exam.id}>
                          <StyledTableCell align="center" component="th" scope="exam">
                            <Checkbox
                              color="primary"
                              className={classes.checkbox}
                              checked={listExamOldAdded.some((x) => x.id === exam.id)}
                              onChange={(event) => handleAddExam(exam)}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="center">{exam?.examTitle}</StyledTableCell>
                          <StyledTableCell align="center">
                            {exam?.examQuestions?.length}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {dateTimeToFormatYYYYHHMM(exam?.startDate)}
                          </StyledTableCell>
                          <StyledTableCell align="center">{exam?.totalPoint}</StyledTableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <EmptyComponent isBorder={false} />
              )}
              {listExam?.totalPages > 1 && (
                <Box mt={3} display="flex" justifyContent="space-between">
                  <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
                    {t("managerTest.tongdethi")}: {listExam.totalElements}
                  </Typography>
                  <Pagination
                    count={Math.ceil(listExam?.totalElements / listExam?.size)}
                    page={listExam?.number + 1}
                    variant="outlined"
                    color="primary"
                    shape="rounded"
                    onChange={(e, page) => handleChangePage(page)}
                  />
                </Box>
              )}
            </Box>
          )}
          {/* <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerTest.phanthuong")}
            </Typography>

            <Box width="80%">
              <SelectField
                options={prizeList?.content}
                name="prizeId"
                control={control}
                label={t("managerTest.chonphanthuong")}
              />
            </Box>
          </Box> */}
          </Box>
          <Box
            style={{
              position: "fixed",
              bottom: 0,
              right: 24,
              left: 280,
              backgroundColor: "#fff",
              padding: "12px 24px",
              boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.15)",
              zIndex: 1200,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              borderTop: "1px solid #E0E0E0",
            }}
          >
            <Button
              type="submit"
              className={classes.btn_create}
              disabled={isOldExam === "true" && listExamOldAdded.length === 0}
            >
              {t("managerTest.batdautaodethi")}
            </Button>
          </Box>
        </form>
      )}

      <ManageExamStudentsModal
        open={openStudentModal}
        onClose={() => setOpenStudentModal(false)}
        classList={classList}
        initialClassIds={watch("classId") || []}
        initialUserIds={watch("userId") || []}
        onSave={(newClassIds, newUserIds) => {
          setValue("classId", newClassIds);
          setValue("userId", newUserIds);
        }}
      />
    </Box>
  );
}
